import { render, staticRenderFns } from "./EscolherNovaCategoria.vue?vue&type=template&id=5a53559d&scoped=true"
import script from "./EscolherNovaCategoria.vue?vue&type=script&lang=ts"
export * from "./EscolherNovaCategoria.vue?vue&type=script&lang=ts"
import style0 from "./EscolherNovaCategoria.vue?vue&type=style&index=0&id=5a53559d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53559d",
  null
  
)

export default component.exports